import React from 'react';
import classnames from 'classnames/bind';
import { Modal, Typography } from 'gd-design-library';
import styles from './InStoreAvailabilityModal.module.scss';
import { InStoreAvailabilityItem } from '@services/cart';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { FiberManualRecord } from '@mui/icons-material';

const CN = 'in-store-availability-modal';
const itemsContainerClassName =`${CN}__items-container`;
const storeItemClassName =`${itemsContainerClassName}__store-item`;
const storeItemNameClassName =`${storeItemClassName}__name`;
const storeItemGridClassName =`${storeItemClassName}__grid`;
const columnTitleClassName = `${storeItemGridClassName}__title`;
const addressClassName = `${storeItemGridClassName}__address`;
const addressTextClassName = `${addressClassName}__text`;
const hoursClassName = `${storeItemGridClassName}__hours`;
const availabilityClassName = `${storeItemGridClassName}__availability`;
const availableClassName = `${availabilityClassName}__available`;
const cx = classnames.bind(styles);


interface Props {
  isOpen: boolean;
  onClose: () => unknown;
  stores: InStoreAvailabilityItem[];
}

export const InStoreAvailabilityModal: React.FC<Props> = ({
  isOpen,
  onClose,
  stores
}) => (
  <Modal
    isOpen={ isOpen }
    onClose={ onClose }
    className={ cx(CN) }
    title='Product availability in stores'
  >
    <Typography>There are {stores.length || 'no'} stores.</Typography>
    <div className={ cx(itemsContainerClassName) }>
      {
        stores.map(({
          ref,
          name,
          isAvailable,
          address: {
            street,
            city,
            state,
            postcode,
            country
          },
          openHours
        }) => (
          <div className={ cx(storeItemClassName) } key={ ref }>
            <Typography className={ cx(storeItemNameClassName) } variant='h5'>{name}</Typography>
            <div className={ cx(storeItemGridClassName) }>
              <div>
                <Typography className={ cx(columnTitleClassName) }>Location</Typography>
                <div className={ cx(addressClassName) }>
                  <LocationOnOutlinedIcon />
                  <Typography className={ cx(addressTextClassName) }>
                    {street}, {city}, {state} {postcode}, {country}
                  </Typography>
                </div>
              </div>
              <div>
                <Typography className={ cx(columnTitleClassName) }>Work hours</Typography>
                {openHours.map(dayOpenHours => (
                  <Typography key={ dayOpenHours } className={ cx(hoursClassName) }>{dayOpenHours}</Typography>
                ))}
              </div>
              <div>
                <Typography className={ cx(columnTitleClassName) }>Availability</Typography>
                <div className={ cx(availabilityClassName) }>
                  <FiberManualRecord
                    className={ cx({
                      [availableClassName]: isAvailable
                    }) }
                    fontSize='small'
                  />
                  <Typography>{isAvailable ? 'In stock' : 'Out of stock'}</Typography>
                </div>
              </div>
            </div>
          </div>
        ))
      }
    </div>
  </Modal>
);
